// import Home from '@/views/Home';
import { BrowserRouter } from "react-router-dom";
import Router from "@/router/index";
// import logo from './logo.svg';

function App() {
  return (
    <BrowserRouter>
      <Router />
      {/* <Router /> */}
    </BrowserRouter>
  )
}

export default App;
